export default {
	readings: {
		general: {
			measure: "Mesure",
			latest: "Dernier",
			history_graph: "Graphique de l'histoire",
			history_map: "Carte de l'histoire",
			alert_parameters: "Paramètres d'alertes",
			alert_reports: "Rapport d'alertes",
			zone_list: "Liste de zones",
			no_readings: "Aucune lecture trouvée",
			no_parameters: "Aucun paramètre trouvé",
			no_zones: "Aucune zone trouvée",
			no_alerts: "Aucune alerte trouvée",
			no_location: "Aucun lieu trouvé",
		},
		hearthrate: {
			name: "Rythme cardiaque",
			unit: "bpm",
			html: "bpm"
		},
		bloodpressure: {
			name: "Tension artérielle",
			unit: "mmHg",
			html: "mmHg"
		},
		temperature: {
			name: "Température",
			unit: "°C",
			html: "°C"
		},
		bloodsaturation: {
			name: "Sang saturation",
			unit: "% spO2",
			html: "% spO<sub>2</sub>"
		},
		position: {
			name: "Position",
			unit: "lat lng",
			html: "lat lng"
		},
		calories: {
			name: "Calories",
			unit: "kcal",
			html: "kcal"
		},
		pedometer: {
			name: "Pédomètre",
			unit: "pas",
			html: "pas"
		},
		falls: {
			name: "Chutes",
			unit: "",
			html: "",
			fall_detected: "Chute détectée"
		},
		falling: {
			name: "Chute",
		},
		Falling: {
			name: "Chute",
		}
	}
}



// WEBPACK FOOTER //
// ./src/i18n/readings/readings_fr.js